"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Pivot/index"), exports);
//# sourceMappingURL=Pivot.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/Pivot.js
// module id = 1031
// module chunks = 0